(() => {
  
    var HelperApp = (() => {
    var getRandomInt = (min, max) => {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    return {
      getRandomInt: getRandomInt
    }
  })();

  var CartUpsellApp = (() => {
    var addToCart = (variantId, button) => {
      if (!variantId || variantId == '') return;
      let extraUnitPrice = 0;
      if (document.body.hasAttribute('price-up-ab-test-a')) {
        extraUnitPrice = 10;
      } else if (document.body.hasAttribute('price-up-ab-test-b')) {
        extraUnitPrice = 30;
      }
      let formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_cart_upsell': true,
            '_extra_unit_price': extraUnitPrice
          }
        }]
      };
      
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      formData.sections = sectionsToBundle.join(",");
      button.classList.add('loading');
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(async (responseJson) => {
        return fetch('/cart.js', {
          method: "GET",
          credentials: "include",
        })
        .then((res) => res.json())
        .then(async (data) => {
          data["sections"] = responseJson["sections"];
          return data;
        });
      })
      .then(data => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: data
          }
        }));
        button.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        button.classList.remove('loading');
    });
    }
    var initialize = () => {
      document.addEventListener('click', (event) => {
        const element = event.target.closest('[js-cart-drawer-upsell-atc]');
        if (!element) return;
        if (element.classList.contains('loading')) return;
  
        const container = element.closest('.cart-drawer__upsell');
        if (!container) return;
        if (container.classList.contains('upsell-added')) return;
      
        const variantId = element.getAttribute('data-variant-id');
        addToCart(variantId, element);
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDMarqueeApp = (() => {
    var intervalIdList = {};
    var play = (element, index) => {
      if (!element || element.classList.contains('playing')) return;
      element.classList.add('playing');
      const intervalId = setInterval(() => {
        let scrollLeft = element.scrollLeft;
        scrollLeft = (scrollLeft+1>element.scrollWidth-element.offsetWidth)?(0):(scrollLeft+1);
        element.scrollTo(scrollLeft, 0);
      }, 45);
      intervalIdList[index] = intervalId;
    }
    var pause = (element, index) => {
      element.classList.remove('playing');
      clearInterval(intervalIdList[index]);
    }
    var initialize = () => {
      document.querySelectorAll('[js-bd-marquee]').forEach((element, index) => {
        element.scrollTo(0, 0);
        play(element, index);
        element.addEventListener('mouseover', () => {
          pause(element, index);
        });
        element.addEventListener('mouseleave', () => {
          play(element, index);
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDTestimonialSliderApp = (() => {
    var initialize = () => {
      document.querySelectorAll('[js-testimonial-slider]').forEach(element => {
        new Flickity(element, {
          prevNextButtons: true,
          adaptiveHeight: false,
          wrapAround: false,
          pageDots: true,
          contain: true,
          imagesLoaded: true,
          cellAlign: 'left'
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDPDPUpsellAssistApp = (() => {
    var updatePDPUpsellInfo = (from_event_flag=false) => {
      let upsellFlagData = localStorage.getItem('[BD data] Upsell Flag') ? JSON.parse(localStorage.getItem('[BD data] Upsell Flag')) : {};
      const mainForm = document.querySelector('[js-main-form]');
      const upsellInfoElement = document.querySelector('[js-pdp-upsell-info-products]');
      if (
        !mainForm ||
        mainForm.getAttribute('data-upsell-pair-id') === '' ||
        !mainForm.getAttribute('data-upsell-pair-id') || 
        !upsellInfoElement ||
        !mainForm.querySelector('buy-buttons [type="submit"]')
      ) return;
      if (upsellFlagData[mainForm.getAttribute('data-upsell-pair-id')] === true) {
        upsellInfoElement.classList.remove('d-none');
        upsellInfoElement.querySelectorAll('[data-flickity]').forEach(element => {
          const flickity = new Flickity(element);
          flickity.resize();
        });
        if (
          mainForm.querySelector('buy-buttons').getAttribute('data-text-after-atc') &&
          mainForm.querySelector('buy-buttons').getAttribute('data-text-after-atc') !== '' &&
          mainForm.querySelector('buy-buttons').getAttribute('data-text-before-atc') &&
          mainForm.querySelector('buy-buttons').getAttribute('data-text-before-atc') !== '' &&
          from_event_flag === true
        ) {
          mainForm.querySelector('buy-buttons [type="submit"]').innerHTML = mainForm.querySelector('buy-buttons').getAttribute('data-text-after-atc');
          setTimeout(() => {
            mainForm.querySelector('buy-buttons [type="submit"]').innerHTML = mainForm.querySelector('buy-buttons').getAttribute('data-text-before-atc');
          }, 3000);
        }
      } else {
        upsellInfoElement.classList.add('d-none');
      }
    }
    var updateLocalStorage = async () => {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      console.log('here is cartContent', cartContent);
      localStorage.removeItem('[BD data] Upsell Flag');
      let upsellFlagData = {};
      Array.from(cartContent.items).forEach(item => {
        if (item.properties?._is_shoe == 'true' && item.properties?._upsell_product_pair_main) {
          upsellFlagData[item.properties._upsell_product_pair_main] = true;
        }
      });
      Array.from(cartContent.items).forEach(item => {
        if (item.properties?._is_shoe == 'true' && item.properties?._upsell_product_pair_upsell) {
          upsellFlagData[item.properties._upsell_product_pair_upsell] = false;
        }
      });
      localStorage.setItem('[BD data] Upsell Flag', JSON.stringify(upsellFlagData));
    }
    var initialize = async () => {
      await updateLocalStorage();
      updatePDPUpsellInfo();
      document.addEventListener('cart:change', async (event) => {
        await updateLocalStorage();
        updatePDPUpsellInfo(true);
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDProductStockNotificationApp = (() => {
    var updateNotification = (container, flag) => {
      if (!container) return;
      const element = container.querySelector('[js-product-stock-notification]');
      if (!element) return;
      if (flag === true) {
        element.classList.remove('out-of-stock');
      } else {
        element.classList.add('out-of-stock');
      }
    }
    var initialize = () => {
      document.querySelectorAll('product-form').forEach(element => {
        element.addEventListener('variant:change', (e) => {
          const currentVariant = e.detail.variant;
          let availableFlag = false;
          if (currentVariant) availableFlag = currentVariant.available;
          updateNotification(element, availableFlag);
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDCollectionCalculatorApp = (() => {
    var setNewTextToProductCardBadge = (element, value) => {
      if (!element) return;
      const originalText = element.getAttribute('data-original-text');
      const calculatedText = element.getAttribute('data-calculated-text');
      const isSingle = String(originalText).includes('-')?false:true;
      if (isSingle) {
        element.textContent = String(calculatedText).replace('((value))', `${parseInt(originalText) + parseInt(value)}cm`);
      }
      else {
        const fromValue = parseInt(String(originalText).split('-')[0]);
        const toValue = parseInt(String(originalText).split('-')[1]);
        element.textContent = String(calculatedText).replace('((value))', `${fromValue + parseInt(value)}-${toValue + parseInt(value)}cm`);
      }
    }
    var setOriginTextToProductCardBadge = (element) => {
      if (!element) return;
      const originalText = element.getAttribute('data-original-text');
      element.textContent = originalText;
    }
    var apply = (container) => {
      if (!container) return;
      const activeElement = container.querySelector('.value-list li.active');
      if (!activeElement) return;
      const value = parseInt(activeElement.textContent);
      const valueElement = container.querySelector('[js-value]');
      if (!valueElement) return;
      valueElement.textContent = value + ' cm';
      closeModal(container);
      document.querySelectorAll('[data-calculated-text][data-original-text]').forEach(element => {
        setNewTextToProductCardBadge(element, value);
      });
    }
    var clear = (container) => {
      if (!container) return;
      const valueElement = container.querySelector('[js-value]');
      if (!valueElement) return;
      valueElement.textContent = '';
      document.querySelectorAll('[data-calculated-text][data-original-text]').forEach(element => {
        setOriginTextToProductCardBadge(element);
      });
    }
    var openModal = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.add('open');
    }
    var closeModal = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.remove('open');
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          openModal(container);
        });
      });
      container.querySelectorAll('[js-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          closeModal(container);
        });
      });
      container.querySelectorAll('[js-apply]').forEach(element => {
        element.addEventListener('click', () => {
          apply(container);
        });
      });
      container.querySelectorAll('[js-clear]').forEach(element => {
        element.addEventListener('click', () => {
          clear(container);
        });
      });
  
      const picker = container.querySelector('.value-list');
      if (!picker) return;
      const ul = picker.querySelector('ul');
      if (!ul) return;
      const MIN = 120, MAX = 220;
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;
  
      for (let i = MIN; i <= MAX; i++) {
        const li = document.createElement('li');
        li.textContent = i;
        ul.appendChild(li);
      }
  
      function updateActive() {
        const items = ul.querySelectorAll('li');
        const centerY = picker.scrollTop + picker.clientHeight / 2;
        let closest = null, best = Infinity;
        items.forEach(li => {
          const liCenter = li.offsetTop + li.offsetHeight / 2;
          const dist = Math.abs(centerY - liCenter);
          li.classList.remove('active');
          if (dist < best) { best = dist; closest = li; }
        });
        if (closest) closest.classList.add('active');
      }
  
      picker.addEventListener('scroll', updateActive);
  
      let scrollTimeout;
      function snapToActive() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const active = ul.querySelector('li.active');
          if (active) {
            picker.scrollTo({
              top: active.offsetTop - picker.clientHeight / 2 + active.offsetHeight / 2,
              behavior: 'smooth'
            });
          }
        }, 120);
      }
      picker.addEventListener('scroll', snapToActive);
  
      picker.addEventListener('mousedown', (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = picker.scrollTop;
        e.preventDefault();
      });
  
      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const delta = e.clientY - startY;
        picker.scrollTop = startScrollTop - delta; // reverse direction for natural feel
      });
  
      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          snapToActive();
        }
      });
  
      const initial = 170;
      const idx = initial - MIN;
      setTimeout(() => {
        const target = ul.children[idx];
        if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 100);
    }
    var initialize = () => {
      document.querySelectorAll('[js-collection-calculator]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDPDPUpsellCollectionModalApp = (() => {
    var close = (container) => {
      if (!container) return;
      container.classList.remove('open');
    }
    var open = (container) => {
      if (!container) return;
      container.classList.add('open');
      container.querySelectorAll('[data-flickity]').forEach(element => {
        const flickity = new Flickity(element);
        flickity.resize();
      });
    }
    var goToCart = (container) => {
      if (!container) return;
      close(container);
      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: JSON.parse(container.getAttribute('data-cart-event-details'))
        }));
      }, 300);
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-close]').forEach(element => {
        element.addEventListener('click', () => {
          close(container);
        });
      });
      container.querySelectorAll('[js-go-to-cart]').forEach(element => {
        element.addEventListener('click', () => {
          goToCart(container);
        });
      });
      document.addEventListener('product:need-upsell-collection', (e) => {
        container.setAttribute('data-cart-event-details', JSON.stringify(e.detail))
        open(container);
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-upsell-collection-modal]').forEach(element => {
        initEachContainer(element);
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDTabContainerApp = (() => {
    var open = (container, data_symbol, data_index) => {
      if (!container || data_index === '') return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        if (element.getAttribute('data-symbol') == data_symbol) {
          element.classList.remove('active');
          if (element.getAttribute('data-index') === data_index) {
            element.classList.add('active');
            if (element.hasAttribute('data-flickity')) {
              const flickity = new Flickity(element);
              flickity.resize();
            }
          }
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab-container] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab-container]'), element.getAttribute('data-symbol'), element.getAttribute('data-index'));
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDProductCardAtcApp = (() => {
    var getProductData = (container) => {
      const productDataElement = container.querySelector('[data-product-data]');
      if (!productDataElement) {
        console.log('No product data element found');
        return null;
      }
      try {
        const data = JSON.parse(productDataElement.textContent);
        console.log('Product data loaded:', data);
        return data;
      } catch (error) {
        console.error('Error parsing product data:', error);
        return null;
      }
    }
  
    var getSelectedVariant = (container, productData) => {
      if (!productData || !productData.variants) {
        console.log('No product data or variants');
        return null;
      }
      
      const variantPicker = container.querySelector('[js-variant-picker]');
      if (!variantPicker) {
        console.log('No variant picker found');
        return null;
      }
      
      const selects = variantPicker.querySelectorAll('select');
      console.log('Found selects:', selects.length);
      if (selects.length === 0) return null;
      
      // Get selected option values (option names, not IDs)
      const selectedOptions = Array.from(selects).map(select => {
        const selectedOption = select.options[select.selectedIndex];
        console.log('Select option:', selectedOption.textContent, 'value:', selectedOption.value, 'index:', select.selectedIndex);
        
        // If the first option is selected (index 0), it's the placeholder, so return null
        if (select.selectedIndex === 0) {
          return null;
        }
        
        return selectedOption.textContent; // Use text content (option name) instead of value
      }).filter(value => value !== null); // Filter out null values (placeholders)
      
      console.log('Selected options (filtered):', selectedOptions);
      console.log('Product options:', productData.options_with_values);
      
      // If not all options are selected, return null
      if (selectedOptions.length !== productData.options_with_values.length) {
        console.log('Not all options selected:', selectedOptions.length, 'vs', productData.options_with_values.length);
        return null;
      }
      
      // Find the variant that matches all selected options
      const matchingVariant = productData.variants.find(variant => {
        const matches = productData.options_with_values.every((option, index) => {
          const match = variant.options[index] === selectedOptions[index];
          console.log(`Option ${index}: variant="${variant.options[index]}" selected="${selectedOptions[index]}" match=${match}`);
          return match;
        });
        return matches;
      });
      
      console.log('Matching variant:', matchingVariant);
      return matchingVariant || null;
    }
  
    var updateButtonVisibility = (container, selectedVariant) => {
      const showButton = container.querySelector('[js-show-button]');
      const atcButton = container.querySelector('[js-product-card-atc]');
      
      console.log('Update button visibility:', { 
        showButton: showButton ? 'found' : 'not found', 
        atcButton: atcButton ? 'found' : 'not found', 
        selectedVariant: selectedVariant ? `variant ${selectedVariant.id}` : 'none' 
      });
      
      if (!showButton || !atcButton) {
        console.log('Missing buttons, cannot update visibility');
        return;
      }
      
      if (selectedVariant) {
        // All options selected, show ATC button
        showButton.classList.add('d-none');
        atcButton.classList.remove('d-none');
        
        // Update ATC button with variant ID
        atcButton.setAttribute('data-variant-id', selectedVariant.id);
        console.log('Showing ATC button for variant:', selectedVariant.id);
        console.log('Button classes - showButton:', showButton.className, 'atcButton:', atcButton.className);
      } else {
        // Not all options selected, show "choose variant" button
        showButton.classList.remove('d-none');
        atcButton.classList.add('d-none');
        atcButton.removeAttribute('data-variant-id');
        console.log('Showing choose variant button');
        console.log('Button classes - showButton:', showButton.className, 'atcButton:', atcButton.className);
      }
    }
  
    var addToCart = (variantId, button) => {
      if (!variantId || variantId == '') return;
  
      let extraUnitPrice = 0;
      if (document.body.hasAttribute('price-up-ab-test-a')) {
        extraUnitPrice = 10;
      } else if (document.body.hasAttribute('price-up-ab-test-b')) {
        extraUnitPrice = 30;
      }
      
      // Get properties from button data attributes
      const properties = {};
      const upsellPairId = button.getAttribute('data-upsell-pair-id');
      const discountPercent = button.getAttribute('data-discount-percent');
      
      if (upsellPairId) {
        properties._upsell_product_pair_upsell = upsellPairId;
      }
      
      if (discountPercent) {
        properties._discount_percent = discountPercent;
      }
  
      if (button.hasAttribute('is-shoe')) {
        properties._is_shoe = 'true';
      }
  
      properties._extra_unit_price = extraUnitPrice;
      
      console.log('Adding to cart with properties:', properties);
      
      let formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: properties
        }]
      };
      
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      formData.sections = sectionsToBundle.join(",");
      button.classList.add('loading');
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(async (responseJson) => {
        return fetch('/cart.js', {
          method: "GET",
          credentials: "include",
        })
        .then((res) => res.json())
        .then(async (data) => {
          data["sections"] = responseJson["sections"];
          return data;
        });
      })
      .then(data => {
        // Close the upsell collection modal if it's open
        const upsellModal = document.querySelector('[js-upsell-collection-modal].open');
        if (upsellModal) {
          upsellModal.classList.remove('open');
        }
        
        // Dispatch cart change event after a short delay to ensure modal is closed
        setTimeout(() => {
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: data
            }
          }));
        }, 100);
        
        button.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        button.classList.remove('loading');
      });
    }
  
    var handleVariantChange = (container) => {
      console.log('handleVariantChange called for container:', container);
      const productData = getProductData(container);
      if (!productData) {
        console.log('No product data in handleVariantChange');
        return;
      }
      
      const selectedVariant = getSelectedVariant(container, productData);
      console.log('Selected variant in handleVariantChange:', selectedVariant);
      updateButtonVisibility(container, selectedVariant);
    }
  
    var initEachContainer = (container) => {
      if (!container) return;
      
      console.log('Initializing BDProductCardAtcApp for container:', container);
      
      const productData = getProductData(container);
      if (!productData) {
        console.log('No product data found, skipping initialization');
        return;
      }
      
      // Initialize button visibility
      handleVariantChange(container);
      
      // Add event listeners to variant picker selects
      const variantPicker = container.querySelector('[js-variant-picker]');
      if (variantPicker) {
        const selects = variantPicker.querySelectorAll('select');
        console.log('Found selects:', selects.length);
        selects.forEach((select, index) => {
          console.log(`Adding change listener to select ${index}:`, select);
          select.addEventListener('change', () => {
            console.log(`Select ${index} changed to:`, select.value, select.options[select.selectedIndex].textContent);
            handleVariantChange(container);
          });
        });
      } else {
        console.log('No variant picker found');
      }
      
      // Add event listener to ATC button
      const atcButton = container.querySelector('[js-product-card-atc]');
      if (atcButton) {
        console.log('Adding click listener to ATC button');
        atcButton.addEventListener('click', (event) => {
          event.preventDefault();
          if (atcButton.classList.contains('loading')) return;
          
          const variantId = atcButton.getAttribute('data-variant-id');
          console.log('ATC button clicked, variant ID:', variantId);
          if (variantId) {
            addToCart(variantId, atcButton);
          }
        });
      } else {
        console.log('No ATC button found');
      }
    }
  
    var initialize = () => {
      console.log('BDProductCardAtcApp initializing...');
      const containers = document.querySelectorAll('[js-product-card-with-variant-picker]');
      console.log('Found containers:', containers.length);
      containers.forEach((element, index) => {
        console.log(`Initializing container ${index}:`, element);
        initEachContainer(element);
      });
    }
  
    return {
      init: initialize
    }
  })();
  
  
  var BDCollectionSizeFilterApp = (() => {
    var openModal = (container) => {
      if (!container || !container.querySelector('[js-modal]')) return;
      container.querySelector('[js-modal]').classList.add('open');
    }
    var closeModal = (container) => {
      if (!container || !container.querySelector('[js-modal]')) return;
      container.querySelector('[js-modal]').classList.remove('open');
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          openModal(container);
        });
      });
      container.querySelectorAll('[js-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          closeModal(container);
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-collection-size-filter]').forEach(element => {
        initEachContainer(element);
      });
    }
    return {
      init: initialize
    }
  })();
  
  
  var BDCollectionFilterApp = (() => {
    var filterProductGrid = (container, section) => {
      if (!container || !section) return;
      const filterSizeList = [];
      container.querySelectorAll('[js-filter-option].checked').forEach(element => {
        if (element.getAttribute('js-filter-option') !== '')
          filterSizeList.push(element.getAttribute('js-filter-option'));
      });
      
      section.querySelectorAll('.product-card').forEach(card => {
        if (filterSizeList.length > 0) {
          card.classList.add('unfiltered');
          for (let i = 0; i < filterSizeList.length; i++) {
            if (card.getAttribute('data-size-values').split(',').includes(filterSizeList[i])) {
              card.classList.remove('unfiltered');
              break;
            }
          }
        } else {
          card.classList.remove('unfiltered');
        }
      });
  
      container.querySelectorAll('[js-filtered-count]').forEach(element => {
        element.innerHTML = section.querySelectorAll('.product-card:not(.unfiltered)').length;
      });
    }
    var clear = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-filter-option].checked').forEach(element => {
        element.click();
      });
    }
    var toggle = (element, container) => {
      if (!element || !container) return;
      if (element.classList.contains('checked')) {
        element.classList.remove('checked');
        container.querySelectorAll('[js-filtered-selected-list]').forEach(selectedListWrapper => {
          const selectedElement = selectedListWrapper.querySelector(`[js-selected-filter-option="${element.getAttribute('js-filter-option')}"]`);
          if (selectedElement) {
            selectedElement.remove();
          }
          if (!selectedListWrapper.querySelector('[js-selected-filter-option]')) {
            selectedListWrapper.classList.add('d-none');
          }
        });
      } else {
        element.classList.add('checked');
        container.querySelectorAll('[js-filtered-selected-list]').forEach(selectedListWrapper => {
          const selectedElement = `
            <div js-selected-filter-option="${element.getAttribute('js-filter-option')}">
              <span>${element.getAttribute('js-filter-option')}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                <path d="M1 0.5L10 9.5M1 9.5L10 0.5" stroke="#26231E"/>
              </svg>
            </div>
          `;
          selectedListWrapper.innerHTML = selectedListWrapper.innerHTML + selectedElement;
          selectedListWrapper.classList.remove('d-none');
        });
      }
      filterProductGrid(container, container.closest('section'));
    }
    var initialize = () => {
      document.querySelectorAll('[js-collection-size-filter] [js-filter-option]').forEach(element => {
        element.addEventListener('click', () => {
          toggle(element, element.closest('[js-collection-size-filter]'));
        });
      });
      document.querySelectorAll('[js-collection-size-filter] [js-clear]').forEach(element => {
        element.addEventListener('click', () => {
          clear(element.closest('[js-collection-size-filter]'));
        });
      });
      document.querySelectorAll('[js-collection-size-filter] [js-filtered-selected-list]').forEach(element => {
        const container = element.closest('[js-collection-size-filter]');
        element.addEventListener('click', (e) => {
          if (e.target.closest('[js-selected-filter-option]')) {
            const filter = container.querySelector(`[js-filter-option="${e.target.closest('[js-selected-filter-option]').getAttribute('js-selected-filter-option')}"]`);
            if (filter) filter.click();
          }
        })
      });
    }
    return {
      init: initialize
    }
  })();
  

  var BDProductCalculatorApp = (() => {
    var updateVariant = (container, variant) => {
      if (!container || !variant || !variant.options) return;
      let result = '';
      for (let i = 0; i < variant.options.length; i++) {
        const variantOption = String(variant.options[i]).toLowerCase();
        if (variantOption.includes('+') && variantOption.includes('cm')) {
          result = variantOption.split('+')[1].split('cm')[0];
          break;
        }
      }
      if (result === '') {
        result = container.getAttribute('data-metafield-shoe-raise');
      }
      container.setAttribute('data-shoe-raise', result);
      apply(container);
    }
    var apply = (container) => {
      if (!container) return;
      container.classList.add('active');
      const activeElement = container.querySelector('.value-list li.active');
      if (!activeElement) return;
      const value = parseInt(activeElement.textContent);
      const valueElement = container.querySelector('[js-value]');
      if (!valueElement) return;
      valueElement.textContent = value + ' cm';
      const beforeValueWrapper = container.querySelector('[js-before-value]');
      const afterValueWrapper = container.querySelector('[js-after-value]');
      if (!beforeValueWrapper || !afterValueWrapper) return;
      beforeValueWrapper.innerHTML = String(beforeValueWrapper.getAttribute('data-template')).replace('((value))', value);
      let newValue = value;
      if (String(container.getAttribute('data-shoe-raise')).includes('-')) {
        const firstValue = parseInt(String(container.getAttribute('data-shoe-raise')).split('-')[0]) + value;
        const lastValue = parseInt(String(container.getAttribute('data-shoe-raise')).split('-')[1]) + value;
        newValue = firstValue + '-' + lastValue;
      } else {
        newValue = parseInt(container.getAttribute('data-shoe-raise')) + value;
      }
      afterValueWrapper.innerHTML = String(afterValueWrapper.getAttribute('data-template')).replace('((value))', newValue);
      closeModal(container);
    }
    var clear = (container) => {
      if (!container) return;
      container.classList.remove('active');
      const valueElement = container.querySelector('[js-value]');
      if (!valueElement) return;
      valueElement.textContent = '';
    }
    var openModal = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.add('open');
    }
    var closeModal = (container) => {
      if (!container) return;
      const modal = container.querySelector('[js-modal]');
      if (!modal) return;
      modal.classList.remove('open');
    }
    var initEachContainer = (container) => {
      if (!container) return;
      container.querySelectorAll('[js-modal-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          openModal(container);
        });
      });
      container.querySelectorAll('[js-modal] [js-close]').forEach(element => {
        element.addEventListener('click', () => {
          closeModal(container);
        });
      });
      container.querySelectorAll('[js-apply]').forEach(element => {
        element.addEventListener('click', () => {
          apply(container);
        });
      });
      container.querySelectorAll('[js-clear]').forEach(element => {
        element.addEventListener('click', () => {
          clear(container);
        });
      });

      document.querySelectorAll('product-form').forEach(element => {
        element.addEventListener('variant:change', (e) => {
          const currentVariant = e.detail.variant;
          updateVariant(container, currentVariant);
        });
      });

      const picker = container.querySelector('.value-list');
      if (!picker) return;
      const ul = picker.querySelector('ul');
      if (!ul) return;
      const MIN = 120, MAX = 220;
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

      for (let i = MIN; i <= MAX; i++) {
        const li = document.createElement('li');
        li.textContent = i;
        ul.appendChild(li);
      }

      function updateActive() {
        const items = ul.querySelectorAll('li');
        const centerY = picker.scrollTop + picker.clientHeight / 2;
        let closest = null, best = Infinity;
        items.forEach(li => {
          const liCenter = li.offsetTop + li.offsetHeight / 2;
          const dist = Math.abs(centerY - liCenter);
          li.classList.remove('active');
          if (dist < best) { best = dist; closest = li; }
        });
        if (closest) closest.classList.add('active');
      }

      picker.addEventListener('scroll', updateActive);

      let scrollTimeout;
      function snapToActive() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const active = ul.querySelector('li.active');
          if (active) {
            picker.scrollTo({
              top: active.offsetTop - picker.clientHeight / 2 + active.offsetHeight / 2,
              behavior: 'smooth'
            });
          }
        }, 120);
      }
      picker.addEventListener('scroll', snapToActive);

      picker.addEventListener('mousedown', (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = picker.scrollTop;
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const delta = e.clientY - startY;
        picker.scrollTop = startScrollTop - delta; // reverse direction for natural feel
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          snapToActive();
        }
      });

      const initial = 170;
      const idx = initial - MIN;
      setTimeout(() => {
        const target = ul.children[idx];
        if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 100);
    }
    var initialize = () => {
      document.querySelectorAll('[js-product-calculator]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();


  var BDProductStockStatusWrapperApp = (() => {
    const STORAGE_KEY = "[BD] Product stock random percent";

    // ---------- utils ----------
    function safeParse(str) {
      try {
        return JSON.parse(str);
      } catch {
        return null;
      }
    }

    function loadStore() {
      const s = safeParse(localStorage.getItem(STORAGE_KEY));
      return s && typeof s === "object" ? s : {};
    }

    function saveStore(store) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    }

    function isSameDay(isoString) {
      const saved = new Date(isoString);
      if (isNaN(saved.getTime())) return false;
      const now = new Date();
      return (
        saved.getFullYear() === now.getFullYear() &&
        saved.getMonth() === now.getMonth() &&
        saved.getDate() === now.getDate()
      );
    }

    function parseRangeFromEl(el) {
      if (!el || !el.getAttribute) return null;
      const minAttr = el.getAttribute("data-min-percent-value");
      const maxAttr = el.getAttribute("data-max-percent-value");

      // If neither exists, no range
      if (minAttr == null && maxAttr == null) return null;

      let minVal = isNaN(parseInt(minAttr, 10)) ? null : parseInt(minAttr, 10);
      let maxVal = isNaN(parseInt(maxAttr, 10)) ? null : parseInt(maxAttr, 10);

      // If one is missing, default it
      if (minVal == null) minVal = 0;
      if (maxVal == null) maxVal = 100;

      // Clamp + swap if needed
      minVal = Math.max(0, Math.min(100, minVal));
      maxVal = Math.max(0, Math.min(100, maxVal));
      if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];

      return { minVal, maxVal };
    }

    // Get product id from either element type:
    // - wrapper: data-product-id
    // - badge: js-stock-badge-message="PRODUCT_ID"
    // - fallback: closest parent [data-product-id]
    function getProductId(el) {
      if (!el || !el.getAttribute) return null;

      const direct = el.getAttribute("data-product-id");
      if (direct) return String(direct);

      const fromBadgeAttr = el.getAttribute("js-stock-badge-message");
      if (fromBadgeAttr) return String(fromBadgeAttr);

      const parent = el.closest && el.closest("[data-product-id]");
      if (parent) {
        const pid = parent.getAttribute("data-product-id");
        if (pid) return String(pid);
      }

      return null;
    }

    // Find the BEST available range for a product:
    // priority: the element we’re initializing (if it has range) -> any wrapper -> any badge -> fallback
    function getBestRangeForProduct(productId, preferredEl) {
      // 1) preferred element range (now badges also have it)
      const preferredRange = parseRangeFromEl(preferredEl);
      if (preferredRange) return preferredRange;

      // 2) any wrapper range
      const wrapper = document.querySelector(
        `[js-stock-status-wrapper][data-product-id="${CSS.escape(productId)}"]`
      );
      const wrapperRange = parseRangeFromEl(wrapper);
      if (wrapperRange) return wrapperRange;

      // 3) any badge range (your new attributes)
      const badge = document.querySelector(
        `[js-stock-badge-message="${CSS.escape(productId)}"]`
      );
      const badgeRange = parseRangeFromEl(badge);
      if (badgeRange) return badgeRange;

      // 4) fallback
      return { minVal: 0, maxVal: 100 };
    }

    function getOrCreatePercent(productId, preferredEl) {
      const store = loadStore();
      const existing = store[productId];

      const range = getBestRangeForProduct(productId, preferredEl);
      const minVal = range.minVal;
      const maxVal = range.maxVal;

      // If already have today's value and it fits the current best range, reuse it.
      if (
        existing &&
        existing.time &&
        typeof existing.data === "number" &&
        isSameDay(existing.time) &&
        existing.data >= minVal &&
        existing.data <= maxVal
      ) {
        return existing.data;
      }

      // Otherwise generate (or regenerate) within best range
      const value = HelperApp.getRandomInt(minVal, maxVal);

      store[productId] = { time: new Date().toISOString(), data: value };
      saveStore(store);

      return value;
    }

    // ---------- rendering ----------
    function updateWrappers(productId, percent) {
      const wrappers = document.querySelectorAll(
        `[js-stock-status-wrapper][data-product-id="${CSS.escape(productId)}"]`
      );

      wrappers.forEach((container) => {
        container.style.setProperty("--percent", percent + "%");
        container.setAttribute("data-bd-percent", String(percent));

        const msg = container.querySelector("[js-percent-message]");
        if (msg && msg.hasAttribute("data-template")) {
          msg.innerHTML = String(msg.getAttribute("data-template")).replace(
            "((value))",
            `<span>${percent}%</span>`
          );
        }
      });
    }

    function updateBadges(productId, percent) {
      // supports either:
      // <div js-stock-badge-message="PRODUCT_ID" ...>
      // OR badges later also filled with data-product-id
      const selector = [
        `[js-stock-badge-message="${CSS.escape(productId)}"]`,
        `[js-stock-badge-message][data-product-id="${CSS.escape(productId)}"]`,
      ].join(",");

      const badges = document.querySelectorAll(selector);

      badges.forEach((badge) => {
        if (!badge.hasAttribute("data-stock-badge-template")) return;
        const tpl = badge.getAttribute("data-stock-badge-template");
        badge.innerHTML = String(tpl).replace("((value))", percent + "%");
      });
    }

    function syncProduct(productId, preferredEl) {
      if (!productId) return;
      const percent = getOrCreatePercent(productId, preferredEl);
      updateWrappers(productId, percent);
      updateBadges(productId, percent);
    }

    function initElement(el) {
      const productId = getProductId(el);
      if (!productId) return;
      syncProduct(productId, el);
    }

    function initAllExisting() {
      document
        .querySelectorAll("[js-stock-status-wrapper], [js-stock-badge-message]")
        .forEach(initElement);
    }

    function observeDynamicAdds() {
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (!m.addedNodes) continue;

          m.addedNodes.forEach((node) => {
            if (!node || node.nodeType !== 1) return;

            if (
              node.matches?.("[js-stock-status-wrapper], [js-stock-badge-message]")
            ) {
              initElement(node);
            }

            node
              .querySelectorAll?.(
                "[js-stock-status-wrapper], [js-stock-badge-message]"
              )
              .forEach(initElement);
          });
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      return observer;
    }

    function initialize() {
      initAllExisting();
      observeDynamicAdds();
    }

    return { init: initialize };
  })();

  var BDCartDrawerUpsellApp = (() => {
    var initialize = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              if (node.matches?.('.cart-drawer__upsell-product-list') || 
                  node.querySelector?.('.cart-drawer__upsell-product-list')) {
                console.log('Element appeared in DOM');
                handleElementAppearance();
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log('Element entered viewport');
            handleElementAppearance();
          }
        });
      }, {
        threshold: 0.1
      });

      function startObserving() {
        const el = document.querySelector('.cart-drawer__upsell-product-list');
        if (el) {
          intersectionObserver.observe(el);
        }
      }

      const container = document.querySelector('.cart-drawer');
      if (container) {
        styleObserver.observe(container, {
          attributes: true,
          attributeFilter: ['class', 'style'],
          subtree: true
        });
      }

      function handleElementAppearance() {
        const element = document.querySelector('.cart-drawer__upsell-product-list .upsell-product-list');
        if (!element) return;

        var flkty = new Flickity( element, {
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          resize: true
        });
        flkty.resize();
      }

      startObserving();
    }
    return {
      init: initialize
    }
  })();

  
  var App = (() => {
    var initialize = () => {
      CartUpsellApp.init();
      BDMarqueeApp.init();
      BDTestimonialSliderApp.init();
      BDPDPUpsellAssistApp.init();
      BDProductStockNotificationApp.init();
      BDCollectionCalculatorApp.init();
      BDPDPUpsellCollectionModalApp.init();
      BDTabContainerApp.init();
      BDProductCardAtcApp.init();
      BDCollectionSizeFilterApp.init();
      BDCollectionFilterApp.init();
      BDProductCalculatorApp.init();
      BDProductStockStatusWrapperApp.init();
      // BDCartDrawerUpsellApp.init();
    }
    return {
      init: initialize
    }
  })();
  
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });


})();